// EXTERNAL DEPENDENCIES
import React from 'react'

// COMPONENTS
import { Container, Row } from '@paypalcorp/pp-react'

// CONSTANTS
import { FULL_WIDTH_CONTAINER_TEST_ID } from '@/constants/test-ids'

// STYLES
import { mainBaseBackgroundColor } from '@/styles/colors'
import styles from './styles.module.less'

/**
 * The FullWidthContainer displays the given children across the entire width of
 * the screen, outside the constraints of the parent container
 */
const FullWidthContainer: React.FC<{
  customBackgroundColor?: string
  customClass?: string
}> = ({ children, customBackgroundColor, customClass }) => {
  return (
    <Row
      data-testid={FULL_WIDTH_CONTAINER_TEST_ID}
      className={styles.fullWidthRowContainer}
      style={{ background: customBackgroundColor || mainBaseBackgroundColor }}
    >
      <Container xxl fluid className={customClass || ''}>
        {children}
      </Container>
    </Row>
  )
}

export default FullWidthContainer
